import React, { useEffect, useState } from "react";
import {
  DetailFields,
  DownArrowDraw,
  DropDownSearchDraw,
  HaberForm,
  RightDrawerContainer,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { Button, Checkbox, Col, Form, Input, Row, Select, Tooltip } from "antd";
import {
  getAllGrades,
  getGradeProductParameter,
  getGradeQualities,
} from "../../../Services/settingsServices";
import { addProduct, getProductsData } from "../../../Services/productServices";
import { getUnitData } from "../../../Services/measurementService";
import {
  currency_List,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
import { capital_letter } from "../../../Utils/helper/helper";
import Iconmoon from "../../../Components/IconsFiles/icon";
const { Option } = Select;

export default function AddProductDrawer({
  closeProductDrawer,
  productDrawer,
  setNewProductData,
  selectedRecord
}) {
  const [form] = Form.useForm();
  const [grades, setGrades] = useState([]);
  const [unitData, setUnitData] = useState();
  const [products, setProducts] = useState([]);
  const [productParam, setProductParam] = useState();
  const [isGradeDropdownOpen, setGradeDropdown] = useState(false);
  const [qualities, setQualities] = useState([]);
  const [isQualityDropdownOpen, setQualityDropdown] = useState(false);
  const [selectGradeType, setSelectGradeType] = useState(false);
  const [selectedRange, setSelectedRange] = useState([]);
  const [productTypes, setProductTypes] = useState("reel");
  const [checkboxCount, setCheckboxCount] = useState(
    // location.state?.action == "add" ? 4 : 0
    4
  );
  const types = [
    { label: "Reel", value: "reel" },
    { label: "Sheet", value: "sheet" },
    { label: "Reel & Sheet", value: "both" },
  ];

  useEffect(() => {
    getAllGrades("enabled")
      .then((response) => {
        setGrades(response.map((grade) => grade.name));
        // console.log("Grades", grades);
      })
      .catch((error) => {
        console.log(error);
      });
    getProductsData("")
      .then((response) => {
        setProducts(response);
        // console.log("Grades", grades);
      })
      .catch((error) => {
        console.log(error);
      });
    getUnitData()
      .then((response) => {
        let data = response.data;
        let perWeight = [];
        for (
          let index = 0;
          index < data.units_management.weight.data.length;
          index++
        ) {
          const unit = data.units_management.weight.data[index];
          perWeight.push({
            value: unit,
            label: "Per " + weightUnit[unit].displayName,
          });
        }

        let filteredCurrency = currency_List.filter((item) =>
          data.units_management.currency.data.includes(item.code)
        );

        data.units_management.weight["perDeafultWeight"] =
          "Per " + weightUnit[data.units_management.weight.default].displayName;
        data.units_management.currency["currencyList"] = filteredCurrency;
        data.units_management.weight["perWeight"] = perWeight;
        setUnitData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if(selectGradeType){
    (async () => {
      // form.setFieldsValue({ quality: "" });
      await getGradeQualities(encodeURIComponent(selectGradeType), "enabled")
        .then((response) => {
          setQualities(response.map((quality) => quality.name));
          console.log("qualities", response);
        })
        .catch((error) => {
          console.log(error);
        });

      await getGradeProductParameter(selectGradeType)
        .then((response) => {
          //setQualities(response.map((quality) => quality.name));
          console.log("qualities", response);
          setProductParam(response);
        })
        .catch((error) => {
          console.log(error);
        });
    })();}
  }, [selectGradeType]);

  const addProductHandler = () => {
    form.submit();
  };

  const onFinish = async (values) => {
    let productName = capital_letter(values.name.trim());
    let body = {
      //code: values.code,
      // name: values.name.charAt(0).toUpperCase() + values.name.slice(1),
      quality:   values?.quality,
      grade:   values?.grade,
      gsm:   values?.gsm,
      ...(values?.burst_factor && { burst_factor: values?.burst_factor }),
      ...(values?.bulk && { bulk: values?.bulk }),
      ply: 1,
      name: productName,
      price: 10000,
      status: values.status,
      remarks: values.remarks,
      type: productTypes,
      ply: [1],
      units: {
        price: "INR",
        per_weight_unit: "t",
      },
      ...(selectedRecord.moisture && { moisture: selectedRecord.moisture })
    };

    

    try {
      const editPoResponse = await addProduct(body);
      console.log(editPoResponse.data);
      setNewProductData(editPoResponse.data)
      closeProductDrawer();
    } catch (error) {
      console.log(error);
      form.setFields([{
        name: "name",
        errors: [error?.response?.data?.msg]
      }])
    }
  };
  const OnGradetoggleSelect = () => {
    setGradeDropdown((prevState) => !prevState);
  };
  const onChangeHandlerGradeBox = (value) => {
    setSelectGradeType(value);
  };
  const OntoggleSelect = () => {
    setQualityDropdown((prevState) => !prevState);
  };
  const checkboxes = Array.from({ length: checkboxCount }, (_, index) => (
    <Col span={6} key={index}>
      <Checkbox value={`${index + 1}`}>
        {" "}
        <span
          style={{
            color: "#323130",
            fontSize: "14px",
            fontFamily: "font-family: var(--sf-pro-text)",
            fontStyle: "normal",
          }}
        >
          {index + 1}
        </span>
      </Checkbox>
    </Col>
  ));
  return (
    <RightDrawerSidebar
      title="Add new Product"
      subtitle=""
      visible={productDrawer}
      onClose={closeProductDrawer}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                form={form}
              >
                <Row className="centerAlign drawerField">
                  <Col span={24}>
                    <div className="">
                      <label>Product Name</label>
                      <p>The product will be identified by this unique name</p>
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="boxFormType">
                      <Form.Item
                        name="name"
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                          {
                            max: 50,
                            message: "Name can have a maximum of 50 characters",
                          },
                          {
                            validator(_, value) {
                              if (
                                value == null ||
                                !products.filter(
                                  (data) =>
                                    data.name.toUpperCase() ===
                                    value.toUpperCase()
                                ).length
                              ) {
                                return Promise.resolve();
                              } else {
                                return Promise.reject(
                                  "This name exists for another product"
                                );
                              }
                            },
                          },
                        ]}
                        className=""
                            initialValue={selectedRecord.productName}
                      >
                        <Input
                          placeholder="Enter name of the Product"
                          style={{ textTransform: "capitalize" }}
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row className="centerAlign ">
                  <Col span={24} className="blockBreak">
                    <Row className="centerAlign drawerField">
                      <Col span={24}>
                        <div className="">
                          <label>Grade</label>
                          <p>Grade of the Product</p>
                        </div>
                      </Col>
                      <Col span={24}>
                        <div className="boxFormType">
                          <Form.Item
                            name="grade"
                            rules={[
                              {
                                required: true,
                                message: "Please select a grade",
                              },
                            ]}
                            initialValue={selectedRecord?.grade}
                          >
                            <Select
                              suffixIcon={
                                isGradeDropdownOpen ? (
                                  <DropDownSearchDraw />
                                ) : (
                                  <DownArrowDraw />
                                )
                              }
                              onBlur={OnGradetoggleSelect}
                              onFocus={OnGradetoggleSelect}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              placeholder={"Select a grade"}
                              onChange={onChangeHandlerGradeBox}
                              disabled={selectedRecord?.grade}
                            >
                              {grades.map((grade) => (
                                <Option key={grade}>{grade}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    <Row className="centerAlign drawerField">
                      <Col span={24}>
                        <div className="">
                          <label>GSM</label>
                          <p>GSM of the product</p>
                        </div>
                      </Col>
                      <Col span={24}>
                        <div className="boxFormType">
                          <Form.Item
                            name="gsm"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                                message:
                                  "Only numeric characters are allowed upto 3 decimal points",
                              },
                            ]}
                            className=""
                            initialValue={selectedRecord.gsm}
                          >
                            <Input placeholder="Enter GSM of the product" 
                            disabled={selectedRecord.gsm}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    {selectedRecord.burst_factor ?(
                      <Row className="centerAlign drawerField">
                        <Col span={24}>
                          <div className="">
                            <label>Burst Factor</label>
                            <p>Burst factor of the product</p>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFormType">
                            <Form.Item
                              name="burst_factor"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                  message:
                                    "Only numeric characters are allowed",
                                },
                              ]}
                              className=""
                              initialValue={selectedRecord.burst_factor}
                            >
                              <Input placeholder="Enter Burst Factor of the product" 
                            disabled
                               />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    ):<></>}
                    <Row className="centerAlign drawerField">
                      <Col span={24}>
                        <div className="">
                          <label>Bulk</label>
                          <p>Bulk of the product</p>
                        </div>
                      </Col>
                      <Col span={24}>
                        <div className="boxFormType">
                          <Form.Item
                            name="bulk"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                                message:
                                  "Only numeric characters are allowed upto 3 decimal points",
                              },
                            ]}
                            className=""
                            initialValue={  selectedRecord.bulk}
                          >
                            <Input placeholder="Enter bulk of the product"
                            disabled={selectedRecord.bulk} 
                             />
                          </Form.Item>
                          <span className="nonEditable">c.c./gm</span>
                        </div>
                      </Col>
                    </Row>
                    {selectedRecord.moisture ?(
                      <Row className="centerAlign drawerField">
                        <Col span={24}>
                          <div className="">
                            <label>Moisture</label>
                            <p>Moisture of the product</p>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="boxFormType">
                            <Form.Item
                              name="moisture"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                                  message:
                                    "Only numeric characters are allowed",
                                },
                              ]}
                              className=""
                              initialValue={  selectedRecord.moisture}
                            >
                              <Input placeholder="Enter moisture of the product"
                              disabled={selectedRecord.moisture}
                               />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    ):<></>}
                    <Row className="centerAlign drawerField">
                      <Col span={24}>
                        <div className="">
                          <label>Quality</label>
                          <p>Quality of the product</p>
                        </div>
                      </Col>
                      <Col span={24}>
                        <div className="boxFormType">
                          {/* The list of qualities will be fetched from configuration global settings */}
                          <Form.Item
                            name="quality"
                            rules={[
                              
                            ]}
                            initialValue={selectedRecord?.quality}
                          >
                            {selectedRecord?.quality?<Input value={selectedRecord.quality} disabled/>
                            :<Select
                              suffixIcon={
                                isQualityDropdownOpen ? (
                                  <DropDownSearchDraw />
                                ) : (
                                  <DownArrowDraw />
                                )
                              }
                              onBlur={OntoggleSelect}
                              onFocus={OntoggleSelect}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              placeholder={"Select a quality"}
                              disabled={true}
                            >
                              {qualities.map((quality) => (
                                <Option key={quality}>{quality}</Option>
                              ))}
                            </Select>}
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    {/* <Row className="centerAlign">
                      <Col span={24}>
                        <div className="">
                          <label>Price</label>
                          <p>Price of the product per weight</p>
                        </div>
                      </Col>
                      <Col span={24}>
                        <Row className="centerAlign ">
                          <Col span={24} className="d-flex threeFields">
                            <div
                              className="boxFormType unitSelect"
                              style={{ marginBottom: "0" }}
                            >
                              <Form.Item
                                name="currency"
                                initialValue={
                                  unitData?.units_management.currency.default
                                }
                              >
                                <Select
                                  placeholder="Unit"
                                  suffixIcon={<DownArrowDraw />}
                                  showSearch
                                >
                                  {unitData?.units_management.currency.currencyList.map(
                                    (currency) => (
                                      <Option key={currency.code}>
                                        <Tooltip title={currency.displayName}>
                                          {`${currency.code}`}
                                        </Tooltip>
                                      </Option>
                                    )
                                  )}
                                </Select>
                              </Form.Item>
                            </div>
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <Form.Item
                                name="price"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: /^\d+(\.\d{1,3})?$|^\.\d{1,3}$/,
                                    message:
                                      "Only decimal characters upto 3 decimal places are allowed",
                                  },
                                ]}
                                className=""
                              >
                                <Input placeholder="Enter price of product in Price/Ton" />
                              </Form.Item>
                            </div>
                            <div
                              className="boxFormType "
                              style={{ marginBottom: "0" }}
                            >
                              <Form.Item
                                name="weight"
                                initialValue={
                                  unitData?.units_management.weight.default
                                }
                              >
                                <Select
                                  placeholder="Unit"
                                  suffixIcon={<DownArrowDraw />}
                                  showSearch
                                >
                                  {unitData?.units_management.weight.perWeight.map(
                                    (weight) => (
                                      <Option key={weight.value}>
                                        {`${weight.label}`}
                                      </Option>
                                    )
                                  )}
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row> */}
                    <Row className="centerAlign drawerField">
                      <Col span={24}>
                        <div className="">
                          <label>Product type</label>
                          <p>The product can be of reel, sheet type or both</p>
                        </div>
                      </Col>
                      <Col span={24}>
                        <div className="boxFormType">
                          <Form.Item
                            name="type"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className="selectForm"
                            initialValue={
                              "both"
                            }
                          >
                            <Select
                              placeholder="Select"
                              suffixIcon={<DownArrowDraw />}
                              onChange={(value) => {
                                setProductTypes(value);
                                if (value === "sheet") {
                                  setSelectedRange([1]);
                                  form.setFieldsValue({ ply_range: [1] }); //
                                } else {
                                  setSelectedRange([]);
                                  form.setFieldsValue({ ply_range: [] });
                                }
                              }}
                              disabled={selectedRecord.type}
                            >
                              {types.map((orderType) => (
                                <Option key={orderType.value}>
                                  {orderType.label}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    {/* <Row className="centerAlign ">
                      <Col span={24}>
                        <div className="">
                          <label>Ply Range</label>
                          <p>Ply count that can be processed by this product</p>
                        </div>
                      </Col>
                      <Col span={24}>
                        <div className="boxFormType">
                          <Form.Item
                            name="ply_range"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            {productTypes === "sheet" ? (
                              // bind value manually via hidden field
                              <>
                                <Checkbox checked disabled>
                                  <span
                                    style={{
                                      color: "#323130",
                                      fontSize: "14px",
                                      fontFamily: "var(--sf-pro-text)",
                                      fontStyle: "normal",
                                    }}
                                  >
                                    1
                                  </span>
                                </Checkbox>
                                <Input type="hidden" value={1} />
                              </>
                            ) : (
                              <Checkbox.Group
                                value={selectedRange}
                                onChange={(checkedValues) => {
                                  setSelectedRange(checkedValues);
                                  form.setFieldsValue({
                                    ply_range: checkedValues,
                                  });
                                }}
                                style={{ width: "100%" }}
                              >
                                <Row gutter={16}>{checkboxes}</Row>
                              </Checkbox.Group>
                            )}
                          </Form.Item>
                        </div>
                      </Col>
                    </Row> */}
                  </Col>
                </Row>
                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      className="themeBtn"
                      // htmlType="submit"
                      onClick={() => addProductHandler()}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                      Add Product
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      //   htmlType="submit"
                      className="themeBtn noBg"
                      onClick={() => closeProductDrawer()}
                    >
                      <Iconmoon icon="cancel" size={16} color="#EA655B" />{" "}
                      Cancel
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
}
